import { define } from '@theme/global';

/* <site-header>
   - PC のドロップダウン／メガメニュー（<details>）をホバーとキーボードで開閉
   - 透過ヘッダーをスクロール・メニュー展開時に不透明へ切り替え
   - 実際の高さを --header-height に反映 */
class SiteHeader extends HTMLElement {
  connectedCallback() {
    this.dropdowns = [...this.querySelectorAll('[data-menu-dropdown]')];
    this.hover = window.matchMedia('(hover: hover) and (min-width: 990px)');

    this.dropdowns.forEach((d) => {
      const summary = d.querySelector('summary');
      d.addEventListener('toggle', () => {
        if (d.open) this.dropdowns.forEach((other) => { if (other !== d) other.open = false; });
        this.updateSolid();
      });
      d.addEventListener('pointerenter', () => {
        if (!this.hover.matches) return;
        clearTimeout(d._closeTimer);
        d.open = true;
      });
      d.addEventListener('pointerleave', () => {
        if (!this.hover.matches) return;
        d._closeTimer = setTimeout(() => { d.open = false; }, 160);
      });
      // ホバーで開いた直後のクリックで閉じてしまわないようにする
      summary?.addEventListener('click', (e) => {
        if (this.hover.matches && d.open && e.detail > 0) e.preventDefault();
      });
      d.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && d.open) {
          d.open = false;
          summary?.focus();
        }
      });
      d.addEventListener('focusout', (e) => {
        if (e.relatedTarget && !d.contains(e.relatedTarget)) d.open = false;
      });
    });

    this.onDocClick = (e) => {
      if (!this.contains(e.target)) this.dropdowns.forEach((d) => { d.open = false; });
    };
    document.addEventListener('click', this.onDocClick);

    if (this.classList.contains('header--transparent')) {
      this.onScroll = () => this.updateSolid();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateSolid();
    }

    this.ro = new ResizeObserver(() => {
      document.documentElement.style.setProperty('--header-height', `${Math.round(this.offsetHeight)}px`);
    });
    this.ro.observe(this);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocClick);
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    this.ro?.disconnect();
  }

  updateSolid() {
    if (!this.classList.contains('header--transparent')) return;
    const solid = window.scrollY > 20 || this.dropdowns.some((d) => d.open);
    this.classList.toggle('is-solid', solid);
  }
}
define('site-header', SiteHeader);
